import styled, { css } from 'styled-components';

import BaseButton from '@components/Button/next';
import FlexContainer from '@components/utils/FlexContainer';

export const Button = styled(BaseButton)`
  width: 100%;
  font-size: 14px;
  font-weight: bold;
  @media (min-width: 801px) {
    width: 137px;
  }
`;
export const PackageVariationDescriptionContainer = styled(FlexContainer)<{
  validated?: boolean;
}>`
  gap: 8px 0px;
  flex-wrap: ${(p) => (p.validated ? undefined : 'wrap')};
  justify-content: space-between;
  @media (max-width: 800px) {
    & > ${FlexContainer} {
      width: 100%;
    }
  }
`;

export const VerificationButtonContainer = styled(FlexContainer)<{
  verified: boolean;
}>`
  flex: 1;
  @media (max-width: 800px) {
    padding-right: 10px;
    ${(p) =>
      p.verified
        ? css``
        : css`
            padding-left: 10px;
          `}
  }
`;

export const customCss = css`
  margin: 0;
  text-align: center;
  padding: 5px 5px;
  margin: 0 0 -20px 0px;
  & span {
    font-size: 12px !important;
    font-weight: 400;
  }
  @media (min-width: 801px) {
    text-align: unset;
    margin: 0 0 0 26px;
    padding: 4px;
    max-width: 265px;
  }
`;

export const VariationCaption = styled.span<{
  length: boolean;
}>`
  height: auto;
  font-size: 16px;
  line-height: normal;
  color: ${(p) => p.theme.palette.darkGrey};
  font-size: 12px;
  padding-left: 37px;
  align-self: flex-start;
  margin-top: -4px;
  margin-bottom: ${(p) => (p.length ? '15px' : '0')};
  max-width: 330px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    height: auto;
    margin-bottom: ${(p) => (p.length ? '5px' : '0')};
  }
`;

export const LoyaltyEarnBadgeWrapper = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  justify-items: right;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    justify-items: left;
    margin-left: 10px;
  }
`;

export const EarnBadgeWrapper = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  justify-items: right;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    justify-items: left;
    margin-left: 10px;
  }
`;
export const EarnBadgeContainer = styled.div`
  padding-bottom: 10px;
`;
export const PackageVariationContainer = styled.div<{
  validated?: boolean;
}>`
  background-color: ${({ theme }) => theme.palette.white};
  padding: 0 8px 0 0;
  margin: 8px 0px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.gray87};
  @media (max-width: 800px) {
    padding: 20px 0px;
  }
`;
